import React, { FC } from 'react';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import { handleDownloadClick } from '@utils/material.utils';
import { Material, MaterialIcon, MaterialLabel, Materials, Preview, Title, Wrapper } from './TrainingMaterial.elements';

export interface TrainingMaterialProps {
    attachments: {
        name: string;
        filename: string;
        _key: string;
        mime_type: string;
    }[];
}

const TrainingMaterialTemplate: FC<TrainingMaterialProps> = ({ attachments }) => {
    const { t } = useTranslations();

    return (
        <Wrapper>
            {attachments?.length > 0 && (
                <>
                    <Title>{t('training.materials.title')}:</Title>
                    <Materials>
                        {attachments?.map((attachment, key) => (
                            <Material
                                onClick={() => handleDownloadClick(attachment._key, attachment.filename)}
                                key={key}
                            >
                                <MaterialIcon name={Icons.File} />
                                <MaterialLabel>{attachment?.name}</MaterialLabel>
                            </Material>
                        ))}
                    </Materials>
                    <Preview>
                        <ButtonTemplate
                            onClick={() =>
                                attachments.map((attachment) =>
                                    handleDownloadClick(
                                        attachment._key,
                                        attachment.filename,
                                        false,
                                        attachment.mime_type
                                    )
                                )
                            }
                            marginTop={25}
                            text={t('material.download.all')}
                        />
                    </Preview>
                </>
            )}
        </Wrapper>
    );
};

export default TrainingMaterialTemplate;
